import store from "../../store";
import { editRoomExtra } from "../../store/rooms/actions";
import BaseHandler from "../BaseHandler";
import { ChannelUpdateSignature, ChannelUpdateSignatureResponse } from "../../proto/ChannelUpdateSignature_pb";

export default class HandleChannelUpdateSignatureResponse extends BaseHandler<ChannelUpdateSignatureResponse, ChannelUpdateSignature> {
  handle() {
    const channelUpdateSignatureResponse = this.response.toObject();

    if (channelUpdateSignatureResponse !== undefined) {
      store.dispatch(
        editRoomExtra({
          roomId: channelUpdateSignatureResponse.roomId,
          channelRoomExtra: {
            signature: channelUpdateSignatureResponse.signature,
          },
        })
      );
    }
  }
}
